import { useState } from 'react';

import { TableCell } from '@mui/material';
import { useStyles } from './reports/styles/ReportTable.styles';
import { SortDescendingIcon } from '@/assets';

export const ReportTableHeader = ({
    header,
    onSort,
}: {
    header: string;
    onSort?: (direction: 'ascending' | 'descending') => void;
}) => {
    const classes = useStyles();

    const [sortDirection, setSortDirection] = useState<string>('descending');

    return (
        <TableCell
            align='left'
            style={{ width: '20%' }}
            onClick={() => {
                if (onSort) {
                    const newDirection = sortDirection === 'ascending' ? 'descending' : 'ascending';
                    setSortDirection(newDirection);
                    onSort(newDirection);
                }
            }}>
            <div className={classes.tableHeaderCell}>
                {header}
                {!onSort ? null : sortDirection === 'descending' ? (
                    <SortDescendingIcon style={{ marginLeft: '5px' }} />
                ) : (
                    <SortDescendingIcon
                        style={{
                            transform: 'rotate(180deg)',
                            marginLeft: '5px',
                        }}
                    />
                )}
            </div>
        </TableCell>
    );
};
